module.exports = __webpack_public_path__ + "static/img/2.3eb1bf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-contrastistas-proveedores/2.png
// module id = nDGY
// module chunks = 0